import { capitalizeEnglishNameWords } from "./capitalize-english-name";

export function formatStudentDisplayName(
  name: string,
  nickname?: string | null,
): string {
  const legal = name.trim();
  const nick = nickname?.trim() ?? "";
  if (!nick) return legal;
  return `(${nick}) ${legal}`;
}

export function normalizeStudentNameFields(
  name: string,
  nickname?: string | null,
): { name: string; nickname: string | null } {
  const legal = capitalizeEnglishNameWords(name.trim());
  const nickRaw = nickname?.trim() ?? "";
  return {
    name: legal,
    nickname: nickRaw ? capitalizeEnglishNameWords(nickRaw) : null,
  };
}
